import { startCase, toLower } from 'lodash';
import Badges from 'modules/common/components/Badge';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useOrgTxnHistory } from '../hooks';

function TransactionHistory() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgTxnHistory(filter, orgUuid);

  const format = [
    {
      label: 'date',
      key: 'created_at',
    },
    {
      label: 'type of transanction',
      key: ({ type }) => <span>{startCase(toLower(type))}</span>,
    },
    {
      id: 'amount',
      key: ({ debit, credit }) => (
        <span>{debit !== '0.00' ? debit : credit}</span>
      ),
      label: 'amount',
    },
    {
      id: 'status',
      key: ({ status }) => <Badges status={status} />,
      label: 'status',
      labelClassName: 'justify-end',
      contentClassName: 'flex justify-end',
    },
  ];

  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default TransactionHistory;
